/**
 * Branding API service
 * Handles fetching, updating, and uploading branding configuration
 */

import { apiClient, apiCall } from './api';
import { BrandingConfig, BrandingUpdate, LogoUploadResponse } from '../types/branding';

/**
 * Get branding configuration for a company
 */
export async function getBranding(companyId: string): Promise<BrandingConfig> {
  return apiCall(() => apiClient.get<BrandingConfig>(`/api/v1/companies/${companyId}/branding`));
}

/**
 * Update branding configuration for a company
 */
export async function updateBranding(
  companyId: string,
  data: BrandingUpdate
): Promise<BrandingConfig> {
  return apiCall(() => apiClient.patch<BrandingConfig>(`/api/v1/companies/${companyId}/branding`, data));
}

/**
 * Upload a logo file for a company
 */
export async function uploadLogo(
  companyId: string,
  file: File
): Promise<LogoUploadResponse> {
  const formData = new FormData();
  formData.append('file', file);
  
  return apiCall(() => 
    apiClient.post<LogoUploadResponse>(`/api/v1/companies/${companyId}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  );
}

export const brandingApi = {
  getBranding,
  updateBranding,
  uploadLogo,
};
